import { render, staticRenderFns } from "./EmailSummary.vue?vue&type=template&id=7b023a67&"
import script from "./EmailSummary.vue?vue&type=script&lang=js&"
export * from "./EmailSummary.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports